import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import {
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    FormControl,
    InputLabel,
    Select,
    Stack,
    TextField,
    Accordion,
    MenuItem
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SectionHeader } from './SectionHeader';
import { fieldTypeOptionsArray } from '../../../constants/constantList';
import LabeledCheckbox from '../../TemplateProperties/TPCheckbox';
import SourceType from '../../TemplateProperties/SourceType';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DatePattern from '../PatternModal/DatePattern';
import { useDispatch, useSelector } from 'react-redux';
import { api } from '../../../redux/api';
import { lgDocPath } from '../../../constants/languageDocPaths';
import CommonGrid from '../../Repository/CommonGrid';
import { removeLowerCaseAndUndefined, stringifyJSONAttributes, stringToBooleanConversion } from '../../../utils/utilFunctions';
import { cloneDeep, debounce } from 'lodash';
import LightTooltip from '../../../commonComponents/LightTooltip';
import { ParentScreenCtx } from '../../../pages/workbench_build/WorkbenchBuild';
import { eachDeep } from "deepdash-es/standalone";
import { treeActions } from '../../../redux/slices/treeSlice';
import AdvancedProperties from './Advanced Properties/AdvancedProperties';
import ResizableBox from '../../Common/ResizableBox';

const styles = {
    fpContainer: {
        // padding: "0 16px 16px 16px"
        padding: "0 4px 4px 4px",
    },
    accordianContainer: {
        border: "none",
        padding: "0",
        margin: "0",
        boxShadow: "none",
        backgroundColor: "unset",
    },
    accordianHeader: {
        border: "none",
        padding: "0",
        margin: "0",
        backgroundColor: "unset",
    },
    accordianContent: {
        border: "none",
        padding: "0 0px",
        margin: "0",
        backgroundColor: "unset",
    },
};

const DynamicClauseValues = ({ dynamicClauses, caller = "" }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const dateRef = useRef(null);
    const queryParams = useSelector((state) => state.queryParams);
    let docPath = `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/DateFormatter.html`;
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
    const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
    const [argName, setArgName] = useState('');
    const [fieldType, setFieldType] = useState('ALPHA');
    const [fieldTypeDropDownItems, setFieldTypeDropDownItems] = useState();
    const [loading, setLoading] = useState(false);
    const [quoteData, setQuoteData] = useState(false);
    const [inboundDatePattern, setInboudDatePattern] = useState('');
    const [datePattern, setDatePattern] = useState('');
    const [openDatePattern, setOpenDatePattern] = useState(false);
    const [valid, setValid] = useState(true);
    const [flag, setFlag] = useState(false);
    const [dpNetworkCallMessage, setDpNetworkCallMessage] = useState('');
    const [rowData, setRowData] = useState([]);
    const [gridApi, setGridApi] = useState('');
    const [selectedColumn, setSelectedColumn] = useState({});
    const selectedColumnRef = useRef(selectedColumn);
    const [updatedColumnsValues, setUpdatedColumnValues] = useState([]);
    const selectedNodeRef = useRef(selectedNode);
    const translatedDataRef = useRef(translatedData);

    const submitChange = (key, val, currentSelectedNode, currentTranslatedData) => {
        // if (key !== 'IN_ARG' && key !== 'RECORD_DETAILS') return;
        val = val.map((item) => removeLowerCaseAndUndefined(item));

        const updatedData = eachDeep(cloneDeep(currentTranslatedData), (objValue) => {
            if (objValue?.key !== currentSelectedNode?.key) {
                return;
            }

                if (objValue && (key === 'IN_ARG' || key === 'RECORD_DETAILS')) {
                if (!Object.isExtensible(objValue)) {
                    objValue = { ...objValue };
                }
                // For GraphQL properties, backend expects RECORD_DETAILS as [{ FIELD: { ... } }, ...]
                if (caller === 'GraphQLProperties' && key === 'RECORD_DETAILS') {
                    objValue[key] = val.map(item => ({ FIELD: item }));
                } else {
                    objValue[key] = val;
                }
                dispatch(
                    treeActions.setRightTreeSelectedNode({
                        screen: parentScreen,
                        type: rightTree.currentTab,
                        data: objValue,
                    })
                );
            }
        });
        dispatch(
            treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: rightTree.currentTab,
                data: updatedData,
            })
        );
    };

    const debounceChangeHandler = useCallback(
      debounce((key, val) => {
        submitChange(
          key,
          val,
          selectedNodeRef.current,
          translatedDataRef.current
        );
      }, 200),
      [
        rightTree.currentTab,
        rightTree.tree,
        rightTree.tree[rightTree.currentTab].translatedData,
      ]
    );

    const columnHandler = (data = [], selectionIndex, gridAPI) => {
        if (!gridAPI) {
            setRowData([]);
            return;
        }

        const rowData = data?.map((e, i) => {
            return { ...e, key: e.ARGNAME, id: i };
        });

        gridAPI.setGridOption('rowData', rowData)
        // setTimeout(() => {
            gridAPI.forEachNode((node) => {
                if (node?.data?.id === selectionIndex) {
                    node.setSelected(true);
                    setSelectedColumn(node.data);
                    selectedColumnRef.current = node.data;
                    gridAPI.ensureNodeVisible(node);
                }
            });

            if (!rowData?.length) {
                setSelectedColumn({});
                selectedColumnRef.current = {};
            }
        // }, 100);
    };

    const testDateHandler = (key, val) => {
        if (!val) {
            setDpNetworkCallMessage(t('BOX_NO_FORMAT_WAS_SPECIFIED__SEL_CANCEL_TO_CLS_DIALOG_AND_RET_TO_MAIN_SCREEN'))
            setValid(false)
        }
        if (val) {
            setLoading(true);
            dispatch(
                api.endpoints.validateDatePattern.initiate({
                    datePattern: encodeURIComponent(val),
                })
            ).then((response) => {
                if (response) {
                    if (response.data.current_state === 'ERROR') {
                        setValid(false)
                        setFlag(false)
                        setDpNetworkCallMessage(response.data.message)

                    } else {
                        if (key === 'fromModal') {
                            setFlag(true)
                            setDpNetworkCallMessage(response.data.message)
                        }
                        setValid(true)
                    }
                }
            })
            .finally(() => {
                setLoading(false);
            })
        }
    };

    const inboundDatePatternModalOkHandler = () => {
        if (flag) {
            if (dateRef.current === 'inDP') {
                setInboudDatePattern(inboundDatePattern);
                submitHandler('INBOUND_PATTERN', inboundDatePattern);
            }
            else {
                setDatePattern(datePattern);
                submitHandler('PATTERN', datePattern);
            }
            setOpenDatePattern(!openDatePattern);
        } else {
            if (dateRef.current === 'inDP') {
                setInboudDatePattern(inboundDatePattern);
                submitHandler('INBOUND_PATTERN', inboundDatePattern);
            }
            else {
                setDatePattern(datePattern);
                submitHandler('PATTERN', datePattern);
            }
            setOpenDatePattern(!openDatePattern);
        }
    };

    const dateInboundPatternModalCancelHandler = () => {
        setOpenDatePattern(false);
    };

    const submitHandler = (key, value, obj) => {
        const nodes = [];
        if(gridApi){
            gridApi.forEachNode((node) => {
                nodes.push(node.data)
            })
        }

        const selectedFromGrid = gridApi && gridApi.getSelectedRows && gridApi.getSelectedRows().length ? gridApi.getSelectedRows()[0] : selectedColumnRef.current;
        const selId = selectedFromGrid?.id;

        for (let i = 0; i < nodes?.length; i++) {
            if (nodes[i]?.id === selId) {
                if (key) {
                    nodes[i] = {
                        ...nodes[i], [key]: value
                    }
                } else {
                    nodes[i] = {
                        ...nodes[i], ...obj
                    }
                }
                break;
            }
        }

        if (gridApi) {
            columnHandler(nodes, selId, gridApi);
        }
        // updateDynamicClauses(nodes);
        caller === 'GraphQLProperties' ? debounceChangeHandler('RECORD_DETAILS', nodes) : debounceChangeHandler('IN_ARG', nodes);
    };
    
    const debounceChange = useCallback(debounce(submitHandler, 200), [
        rightTree.currentTab,
        rightTree.tree,
        rightTree.tree[rightTree.currentTab].translatedData,
        dynamicClauses
      ]);
    
    const handleDatePatternChange = (value) => {
        setDatePattern(value);
        setDpNetworkCallMessage('');
        setValid(true);
        setFlag(false);
        debounceChange('PATTERN',value);
    }  
    const dataSourceHandler = (values, sourceType) => {
        const isDateMapped = values.FIELDTYPE === "DATE";
        if (values.hasOwnProperty("FIELDTYPE")) delete values?.FIELDTYPE;
        submitHandler(null, null, {...values, isDateMapped, ...(sourceType && { SOURCE_TYPE: sourceType })});
    };

    const customClickHandlerOnAdd = (e) => {
        const newColumn = {
            ARGNAME: 'UNNAMED',
            ARGTYPE: 'IN',
            FIELDTYPE: 'ALPHA',
            ICON_DISPLAY: 'IN_ARG',
            MAPNAME: 'UNNAMED',
            // QUOTE_DATA: 'FALSE',
            // RECORD_TYPE: '',
            // SOURCE_TYPE: '',
            // PARENT: '',
            // ACTION: '',
            // INDEX: '',
            key: selectedColumn?.id,
        }
        const data = [];
        const selectedRows = e.api.getSelectedRows();
        e.api.forEachNode((node) => {
            data.push(node.data);
        });
        data.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, {
            ...newColumn,
        });
        columnHandler(
            [...data],
            data.length && selectedRows?.length ? +selectedRows?.[0]?.id + 1 : 0,
            e.api
        );
        // updateDynamicClauses(data);
        caller ==='GraphQLProperties' ? debounceChangeHandler('RECORD_DETAILS', data) : debounceChangeHandler('IN_ARG', data);
    }

    const deleteActionHandler = (e) => {
        const data = [];
        e.api.forEachNode((node) => {
            if (e.data.id !== node.data.id) data.push(node.data);
        });
        columnHandler([...data], 0, e.api);
        // updateDynamicClauses(data);
        caller === 'GraphQLProperties' ? debounceChangeHandler('RECORD_DETAILS', data) : debounceChangeHandler('IN_ARG', data);
    };

    const handleRow = (options) => {
        const selectedRows = options.api.getSelectedRows();
        const sel = selectedRows && selectedRows.length ? selectedRows[0] : {};
        setSelectedColumn(sel);
        selectedColumnRef.current = sel;
        options.api.redrawRows();
    }

    const updatedSelectedNodeWithAdvanceProperties = (val) => {
        // Apply advanced properties object to the currently selected column in the grid
        if (!gridApi) return;
        const nodes = [];
        gridApi.forEachNode((node) => {
            nodes.push(node.data);
        });
        const selId = selectedColumn?.id;
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i]?.id === selId) {
                let newNode = { ...nodes[i] };
                Object.keys(val || {}).forEach((prop) => {
                    if (prop === 'CHANGED') return;
                    const v = val[prop];
                    if (v === '' || v === undefined || v === null) {
                        // remove empty properties
                        delete newNode[prop];
                    } else {
                        newNode[prop] = v;
                    }
                });
                nodes[i] = newNode;
                break;
            }
        }

        columnHandler(nodes, selId, gridApi);
        debounceChangeHandler('RECORD_DETAILS', nodes);
    };

    const CustomCellRenderer = (info) => {
        const { value } = info;
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "2rem",
                }}
            >
                <div className='truncated-text' title={value}>
                    {value}
                </div>
                <div className='flex align-center'>
                    <LightTooltip onClick={() => deleteActionHandler(info)}>
                        <span
                            style={{ cursor: "pointer" }}
                            className='DELETE_MUI'
                        ></span>
                    </LightTooltip>
                </div>
            </div>
        );
    };

    const gridOptions = {
        columnDefs: [
            {
                addNewControl: true,
                addControlLabel: t("HOVER_MSSG_ADD_DYNAMIC_CLAUSE"),
                headerName: caller === "GraphQLProperties" ? t("LBL_GRAPHQL_VAR") :t("LBL_DYNAMIC_WHERE_CLAUSE_VALUES"),
                field: "key",
                customClickHandlerOnAdd: customClickHandlerOnAdd,
                cellRenderer: (info) => CustomCellRenderer(info),
                editable: false,
                resizable: false,
            },
        ],
        suppressMovableColumns: true,
    };

    useEffect(() => {
        const fieldTypeDropDownItems = [...fieldTypeOptionsArray].map((obj, key) => (
            <MenuItem key={key} value={obj.value}>
                {t(obj.text)}
            </MenuItem>
        ));
        setFieldTypeDropDownItems(fieldTypeDropDownItems);
    }, [fieldTypeOptionsArray]);

    useEffect(() => {
        setValid(true);
        setDpNetworkCallMessage("");
    }, [openDatePattern]);

    useEffect(() => {
        if ((selectedColumn?.ARGNAME?.startsWith('%') && selectedColumn?.ARGNAME?.endsWith('%'))) {
            const argName = selectedColumn.ARGNAME?.slice(1, -1);
            setArgName(argName || '');
        } else setArgName(selectedColumn?.ARGNAME)
        setFieldType(selectedColumn.FIELDTYPE || 'ALPHA');
        setInboudDatePattern(selectedColumn?.INBOUND_PATTERN ? selectedColumn?.INBOUND_PATTERN : '');
        setDatePattern(selectedColumn?.PATTERN ? selectedColumn.PATTERN : '');
        setQuoteData(stringToBooleanConversion(selectedColumn.QUOTE_DATA) || false);
    }, [selectedColumn]);
    
    useEffect(() => {
        columnHandler(dynamicClauses || [], 0, gridApi);
    }, [dynamicClauses, gridApi])

    useEffect(() => {
        if (selectedNodeRef.current !== selectedNode) {
            selectedNodeRef.current = selectedNode;
        }
    }, [selectedNode]);

    useEffect(() => {
        if (translatedDataRef.current !== translatedData) {
            translatedDataRef.current = translatedData;
        }
    }, [translatedData]);

    return (
      <Box sx={{ padding: "8px" }}>
        <Stack spacing={"15px"}>
            <ResizableBox>
                <CommonGrid
                gridOptions={gridOptions}
                rowData={rowData}
                getGridAPI={(gridOptions, gridApi) => {
                    setGridApi(gridApi.api);
                    columnHandler(dynamicClauses || [], 0, gridApi.api);
                }}
                containerStyle={{ height: "100% !important" }}
                gridResizable={true}
                gridProps={{
                    rowSelection: "single",
                    onSelectionChanged: handleRow,
                }}
                />
            </ResizableBox>
          {Object.keys(selectedColumn).length !== 0 && (
            <>
              <FormControl>
                <TextField
                  variant="outlined"
                  size="small"
                  label={t("LBL_ARG_NAME")}
                  type="text"
                  className={"width-100"}
                  name={"ARGNAME"}
                  value={argName || ""}
                  autoComplete="off"
                  onBlur={(e) => {
                    const val = `%${e.target.value}%`;
                    debounceChange("ARGNAME", val);
                  }}
                  onChange={(e) => {
                    setArgName(e.target.value);
                  }}
                />
              </FormControl>
              <div className="flex" style={{ gap: "10px" }}>
                <FormControl
                  variant="outlined"
                  sx={{ width: "70%" }}
                  size="small">
                  <InputLabel id="ftDropdownLabel">
                    {t("LBL_FLD_TYPE")}
                  </InputLabel>
                  <Select
                    className={"width-100"}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 300,
                        },
                      },
                    }}
                    name={"FIELDTYPE"}
                    value={fieldTypeDropDownItems?.length ? fieldType : ""}
                    labelId="ftDropdownLabel"
                    label={t("LBL_FLD_TYPE")}
                    id="ftDropdown"
                    onChange={(e) => {
                      setFieldType(e.target.value);
                      debounceChange(e.target.name, e.target.value);
                    }}>
                    {fieldTypeDropDownItems}
                  </Select>
                </FormControl>
                <LabeledCheckbox
                  label={t("BTN_QUOTE_DATA")}
                  handleCheck={(checked) => {
                    setQuoteData(checked);
                    debounceChange(
                      "QUOTE_DATA",
                      stringifyJSONAttributes(checked)
                    );
                  }}
                  checked={quoteData}
                />
              </div>
              <Accordion defaultExpanded sx={styles.accordianContainer}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="accordianFormattingOptions"
                  id="dataSource"
                  className="accordian-override"
                  sx={styles.accordianHeader}>
                  <SectionHeader text={`${t("LBL_DATA_SOURCE")}`} />
                </AccordionSummary>
                <AccordionDetails sx={styles.accordianContent}>
                  <SourceType
                    node={{
                      PARENT: selectedColumn?.PARENT,
                      MAPNAME: selectedColumn?.MAPNAME,
                      RECORD_TYPE: selectedColumn?.RECORD_TYPE,
                      ACTION: selectedColumn?.ACTION,
                      INDEX: selectedColumn?.INDEX,
                      CUSTOM_DB_FIELD: selectedColumn?.CUSTOM_DB_FIELD,
                      PLUGIN_NAME: selectedColumn?.PLUGIN_NAME,
                      key: selectedColumn?.id,
                    }}
                    initialSelectCall={true}
                    valuesHandler={dataSourceHandler}
                    hideOutboundOption={caller === "GraphQLProperties"}
                  />
                </AccordionDetails>
              </Accordion>
              {fieldType === "DATE" && (
                <Accordion defaultExpanded sx={styles.accordianContainer}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="accordianFormattingOptions"
                    id="dataSource"
                    className="accordian-override"
                    sx={styles.accordianHeader}>
                    <SectionHeader text={`${t("LBL_FORMATE_OPTIONS")}`} />
                  </AccordionSummary>
                  <AccordionDetails sx={styles.accordianContent}>
                    <Stack padding={"10px 0px"} spacing={"15px"}>
                      <FormControl className="width-100" size="small">
                        <div className="flex">
                          <TextField
                            variant="outlined"
                            size="small"
                            label={t("LBL_INBOUND_DATE_PATTERN")}
                            type="text"
                            className={"width-100"}
                            name={"INBOUND_DATE_PATTERN"}
                            value={inboundDatePattern}
                            disabled={
                              ["TODAY", "YESTERDAY", "TOMORROW"].includes(
                                selectedColumn?.INBOUND_PATTERN
                              ) || selectedColumn?.isDateMapped
                            }
                            autoComplete="off"
                            onChange={(e) => {
                              setInboudDatePattern(e.target.value);
                              debounceChange("INBOUND_PATTERN", e.target.value);
                              setDpNetworkCallMessage("");
                              setValid(true);
                              setFlag(false);
                            }}
                          />
                          <Button
                            variant="outlined"
                            size="small"
                            disableElevation
                            className="margin-left-4"
                            sx={{
                              width: "40px",
                              padding: "4px 8px",
                              minWidth: "40px",
                            }}
                            onClick={() => {
                              setOpenDatePattern(true);
                              dateRef.current = "inDP";
                            }}>
                            <MoreHorizIcon fontSize="small" />
                          </Button>
                        </div>
                      </FormControl>
                      <FormControl className="width-100" size="small">
                        <div className="flex">
                          <TextField
                            variant="outlined"
                            size="small"
                            label={t("LBL_PATTERN")}
                            type="text"
                            className={"width-100"}
                            name={"PATTERN"}
                            value={datePattern || ""}
                            autoComplete="off"
                            onChange={(e) => {
                              handleDatePatternChange(e.target.value);
                            }}
                          />
                          <Button
                            variant="outlined"
                            size="small"
                            disableElevation
                            className="margin-left-4"
                            sx={{
                              width: "40px",
                              padding: "4px 8px",
                              minWidth: "40px",
                            }}
                            onClick={() => {
                              setOpenDatePattern(true);
                              dateRef.current = "DP";
                            }}>
                            <MoreHorizIcon fontSize="small" />
                          </Button>
                        </div>
                      </FormControl>
                    </Stack>
                  </AccordionDetails>
                </Accordion>
              )}
            </>
          )}
          {caller && caller === "GraphQLProperties" && Object.keys(selectedColumn).length > 0 && (
            <AdvancedProperties
              selectedNode={selectedColumn}
              updatedSelectedNodeWithAdvanceProperties={
                updatedSelectedNodeWithAdvanceProperties
              }
            />
          )}
        </Stack>
        <DatePattern
          openModal={openDatePattern}
          docPath={docPath}
          okHandler={inboundDatePatternModalOkHandler}
          cancelHandler={dateInboundPatternModalCancelHandler}
          onChangeHandler={
            dateRef.current === "inDP" ? setInboudDatePattern : setDatePattern
          }
          testDateHandler={testDateHandler}
          dpNetworkCallMessage={dpNetworkCallMessage}
          datePattern={
            dateRef.current === "inDP" ? inboundDatePattern : datePattern
          }
          valid={valid}
          loading={loading}
        />
      </Box>
    );
}

export default DynamicClauseValues
